const $ = require('jquery')
getCookie = function (name) {
  var cookieValue = null;
  if (document.cookie && document.cookie !== '') {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
          var cookie = jQuery.trim(cookies[i]);
          // Does this cookie string begin with the name we want?
          if (cookie.substring(0, name.length + 1) === (name + '=')) {
              cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
              break;
          }
      }
  }
  return cookieValue;
}

$(document).ready(function () {
  $('.js-body').on('click', '.js-btn-bookmark-episode', function () {
    episodeId = $(this).attr('data-id');
    csrftoken = getCookie('csrftoken');
    $.ajax({
      type: "POST",
      url: '/bookmark',
      data: {
        id: episodeId, 
        csrfmiddlewaretoken: csrftoken
      },
      dataType: 'JSON',
      success: function (data) {  
        if (data.bookmark == true) {
          $('#btn-bookmark-episode-' + episodeId).html('<i class="fas fa-bookmark"></i><span class="episode-meta-text"> ذخیره</span>')
        } else {
          $('#btn-bookmark-episode-' + episodeId).html('<i class="far fa-bookmark"></i><span class="episode-meta-text"> ذخیره</span>')
        }
      }
    });
  })
})

